import React from 'react';
import { Card } from './ui/card';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mockData';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';

const Testimonials = () => {
  const { isDark } = useTheme();
  const { t } = useTranslation();
  
  return (
    <div 
      className="py-20 px-4 transition-colors duration-300"
      style={{
        background: isDark 
          ? 'linear-gradient(to bottom, #0a0a0a 0%, #000000 100%)'
          : 'linear-gradient(to bottom, #fefefe 0%, #ffffff 100%)'
      }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 
            className="text-4xl md:text-5xl font-bold mb-4 transition-colors duration-300"
            style={{ 
              color: isDark ? '#ffff00' : '#f59e0b',
              textShadow: isDark ? '0 0 30px rgba(255, 255, 0, 0.8), 0 0 50px rgba(255, 255, 0, 0.5)' : '0 0 25px rgba(245, 158, 11, 0.6), 0 0 40px rgba(245, 158, 11, 0.4)'
            }}
          >
            {t('testimonials.title')}
          </h2>
          <p 
            className="text-lg transition-colors duration-300"
            style={{ 
              color: isDark ? '#00ff88' : '#10b981',
              textShadow: isDark ? '0 0 10px rgba(0, 255, 136, 0.6)' : '0 0 10px rgba(16, 185, 129, 0.5)'
            }}
          >
            {t('testimonials.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={testimonial.id}
              className="p-6 transition-all duration-300 hover:scale-105"
              style={{
                backgroundColor: isDark ? '#0a0a0a' : '#ffffff',
                borderColor: isDark ? '#00ffff' : '#0ea5e9',
                borderWidth: '2px',
                boxShadow: isDark ? '0 0 30px rgba(0, 255, 255, 0.3)' : '0 0 25px rgba(14, 165, 233, 0.35)'
              }}
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              
              <p 
                className="mb-4 text-sm leading-relaxed transition-colors duration-300"
                style={{ color: isDark ? '#ffffff' : '#475569' }}
              >
                "{testimonial.text}"
              </p>

              <div 
                className="flex items-center gap-3 mt-4 pt-4 border-t transition-colors duration-300"
                style={{ borderColor: isDark ? '#333' : '#e2e8f0' }}
              >
                <div 
                  className="w-10 h-10 rounded-full overflow-hidden"
                  style={{ backgroundColor: isDark ? '#000' : '#f1f5f9' }}
                >
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p 
                    className="font-semibold text-sm transition-colors duration-300"
                    style={{ 
                      color: isDark ? '#ff00ff' : '#d946ef',
                      textShadow: isDark ? '0 0 8px rgba(255, 0, 255, 0.5)' : '0 0 6px rgba(217, 70, 239, 0.4)'
                    }}
                  >
                    {testimonial.name}
                  </p>
                  <p 
                    className="text-xs transition-colors duration-300"
                    style={{ color: isDark ? '#888' : '#94a3b8' }}
                  >
                    {testimonial.business}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
